import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { Input } from '@/components/atoms/input'
import { Modal } from '@/components/molecules'
import { Field } from '@/components/molecules/field'

type Props = {
  open: boolean
  onClose: () => void
  title: string
  subtitle: string
  value: string
  onChange: (value: string) => void
  placeholder: string
  submitLabel: string
  onSubmit: () => void
}

type ManualQrForm = {
  qrCode: string
}

const qrCodeSchema = yup.object({
  qrCode: yup
    .string()
    .trim()
    .required('Code is required')
    .matches(/^[A-Za-z0-9_:\-\.]{6,256}$/i, 'Invalid QR code format')
})

export const ModalManualInput: React.FC<Props> = ({
  open,
  onClose,
  title,
  subtitle,
  value,
  onChange,
  placeholder,
  submitLabel,
  onSubmit
}) => {
  const form = useForm<ManualQrForm>({
    defaultValues: { qrCode: value },
    resolver: yupResolver(qrCodeSchema),
    mode: 'onChange'
  })

  const {
    control,
    watch,
    setValue,
    formState: { errors, isSubmitting },
    handleSubmit
  } = form

  useEffect(() => {
    setValue('qrCode', value, { shouldValidate: true, shouldDirty: true })
  }, [value, setValue])

  const watched = watch('qrCode')
  useEffect(() => {
    onChange(watched || '')
  }, [watched, onChange])

  const handleClose = () => onClose()

  const onValidSubmit = async () => {
    await onSubmit()
  }

  return (
    <Modal
      isOpen={open}
      onClose={handleClose}
      title={title}
      description={subtitle}
      positiveLabel={submitLabel}
      renderAction={true}
      loading={isSubmitting}
      onOk={handleSubmit(onValidSubmit)}
      size='small'
    >
      <Field name='qrCode' isRequired>
        <Field.InputController controller={control} errors={errors}>
          <Field.Label>Code</Field.Label>
          <Input id='manual-qr-code' placeholder={placeholder} fullWidth aria-label='Manual QR code input' autoFocus />
        </Field.InputController>
      </Field>
    </Modal>
  )
}
